import { render, staticRenderFns } from "./7Questionnaire3.vue?vue&type=template&id=0a4ce826"
import script from "./7Questionnaire3.vue?vue&type=script&lang=js"
export * from "./7Questionnaire3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports